import { VueReCaptcha } from 'vue-recaptcha-v3'

export default defineNuxtPlugin((nuxtApp) => {
	const { public: publicRuntimeConfig } = useRuntimeConfig()
	const isRecaptchaEnabled = String(publicRuntimeConfig.recaptchaEnabled).toLowerCase() !== 'false'
	const recaptchaSiteKey = String(publicRuntimeConfig.recaptchaSiteKey || '')

	if (!isRecaptchaEnabled || !recaptchaSiteKey) {
		return
	}

	nuxtApp.vueApp.use(VueReCaptcha, {
		siteKey: recaptchaSiteKey,
		loaderOptions: {
			autoHideBadge: false,
			explicitRenderParameters: {
				badge: 'bottomright',
			},
		},
	})
})
